import { useAuth } from "../composables/useAuth.mjs";
import { useLog } from "../composables/useLog.mjs";
import { useRoute } from "../composables/useRoute.mjs";
import { smvpGetOAuthAuthorization } from "../lib/smvpGetOAuthAuthorization.mjs";
import {
  addRouteMiddleware,
  defineNuxtPlugin,
  callWithNuxt,
  useNuxtApp,
  navigateTo
} from "#app";
export default defineNuxtPlugin(() => {
  addRouteMiddleware("smvp-pageauth", async (to) => {
    const nuxtApp = useNuxtApp();
    if (useAuth.getToken() === null) {
      if (useLog.getLogFlag())
        console.log(
          /* @__PURE__ */ new Date(),
          "saasmvp OAUTH smvp-pageauth.ts client middleware: ROUTE:",
          to.path,
          "*** UNAUTHORIZED ***"
        );
      return callWithNuxt(nuxtApp, navigateTo, [useRoute.getRoute()]);
    }
    let status = 0;
    status = await smvpGetOAuthAuthorization();
    if (status == 200) {
      if (useLog.getLogFlag())
        console.log(
          /* @__PURE__ */ new Date(),
          "saasmvp OAUTH smvp-pageauth.ts client middleware: ROUTE:",
          to.path,
          "*** AUTHORIZED ***"
        );
    } else {
      if (useLog.getLogFlag())
        console.log(
          /* @__PURE__ */ new Date(),
          "saasmvp OAUTH smvp-pageauth.ts client middleware: ROUTE:",
          to.path,
          "*** JWT Token Expired ***"
        );
      useAuth.setLogout();
      return callWithNuxt(nuxtApp, navigateTo, [useRoute.getRoute()]);
    }
  });
});
